import React, {
    useEffect,
    useImperativeHandle,
    useRef,
    forwardRef,
} from "react";

const CkEditorComponent = forwardRef(({ value, onChange, name_editor }, ref) => {
    const editorRef = useRef(null);         // CKEditor instance
    const hasSetInitialValue = useRef(false); // Để tránh setData nhiều lần

    useEffect(() => {
        // Load CKEditor nếu chưa có
        if (!window.CKEDITOR) {
            const script = document.createElement("script");
            script.src = "/assets/ckeditor/ckeditor.js"; // ✅ Đường dẫn tới ckeditor.js
            script.onload = () => initEditor();
            document.body.appendChild(script);
        } else {
            initEditor();
        }

        // Cleanup khi unmount
        return () => {
            if (window.CKEDITOR.instances[name_editor]) {
                window.CKEDITOR.instances[name_editor].destroy();
            }
        };
    }, []);

    useEffect(() => {
        // ✅ Chỉ setData 1 lần để tránh ghi đè khi người dùng đang nhập
        if (
            editorRef.current &&
            value !== undefined &&
            value !== null &&
            !hasSetInitialValue.current
        ) {
            editorRef.current.setData(value || "");
            hasSetInitialValue.current = true;
        }
    }, [value]);

    const initEditor = () => {
        if (window.CKEDITOR.instances[name_editor]) {
            window.CKEDITOR.instances[name_editor].destroy();
        }

        const editor = window.CKEDITOR.replace(name_editor, {
            height: 300,
            language: "vi",
            toolbar: [
                { name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
                { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'SpellChecker', 'Scayt'] },
                {
                    name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton',
                        'HiddenField']
                },
                '/',
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
                {
                    name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv',
                        '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl']
                },
                { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                { name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
                '/',
                { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                { name: 'colors', items: ['TextColor', 'BGColor'] },
                { name: 'tools', items: ['Maximize', 'ShowBlocks', 'About'] }
            ],
        });

        editor.on("instanceReady", () => {
            // Đã được handle bằng useEffect
        });

        editor.on("change", () => {
            const data = editor.getData();
            if (onChange) {
                onChange(data);
            }
        });

        editorRef.current = editor;
    };
    // Expose method cho component cha
    useImperativeHandle(ref, () => ({
        insertText: (text) => {
            const editor = editorRef.current;
            if (editor) {
                editor.focus();
                editor.insertText(text);
            }
        },
        insertHtml: (html) => {
            const editor = editorRef.current;
            if (editor) {
                editor.focus();
                editor.insertHtml(html);
            }
        },
        getData: () => editorRef.current?.getData(),
        setData: (data) => editorRef.current?.setData(data),
    }));

    return <textarea id={name_editor} />;
});

export default CkEditorComponent;
